<template>
    <div class="container min-full">
        <button class="back" @click="refreshCourses()"><svg-icon icon="refresh" width="32" /></button>
        <h1 class="mb-5">{{ $t('myCourses') }}</h1>
        <LoadingSpinner v-if="loading" />
        <template v-else>
            <b-list-group class="flex-row flex-wrap">
                <CourseBlock v-for="course in courses" :key="course.id" :course="course" />
            </b-list-group>
            <p v-if="loadError" class="text-center">{{ $t(loadError) }}</p>
            <p v-else-if="courses.length === 0" class="text-center">{{ $t('noCourses') }}</p>
        </template>
    </div>
</template>
<script>
import SvgIcon from '@/components/SvgIcon';
import CourseService from '../services/CourseService';
import CourseBlock from '../components/CourseBlock';
import LoadingSpinner from '@/components/loader/Loader';
import { sites } from 'sites-config';
import { isAuthExpiredError } from '@/common/auth';
import { getListNetworkErrorMessage, notifyError } from '@/common/network';

export default {
    name: 'CourseScreen',
    components: {
        CourseBlock,
        LoadingSpinner,
        SvgIcon
    },
    data() {
        return {
            courses: [],
            loading: true,
            loadError: null,
        }
    },
    mounted(){
        this.getCourses();
        window.addEventListener('online', () => {
            this.refreshCourses();
        });
        window.addEventListener('offline', () => {
            this.refreshCourses();
        });
    },
    beforeDestroy(){
        window.removeEventListener('online', () => {
            this.refreshCourses();
        });
        window.removeEventListener('offline', () => {
            this.refreshCourses();
        });
    },
    methods: {
        refreshCourses() {
            this.loading = true;
            this.getCourses();
        },
        async getCourses() {
            try {
                this.loadError = null;
                const response = await CourseService.getCourses();
                if (this.$store.state.site.id === 0) {
                    const excludedProviderIds = Object.values(sites).map(site => site.id);
                    response.courses = response.courses.filter(
                        a => {
                            if (this.$store.getters.getIsTrainer) {
                                return !excludedProviderIds.includes(a.course_provider_id);
                            }
                            return !excludedProviderIds.includes(a.provider_id);
                        }
                    );
                } else {
                    response.courses = response.courses.filter(
                        a => {
                            if (this.$store.getters.getIsTrainer) {
                                return a.course_provider_id === this.$store.state.site.id;
                            }
                            return a.provider_id === this.$store.state.site.id;
                        }
                    );
                }
                this.courses = response.courses;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                if (isAuthExpiredError(error)) {
                    return;
                }
                notifyError(error, {
                    source: {
                        screen: 'CoursesScreen',
                        action: 'getCourses',
                    },
                });
                this.courses = [];
                this.loadError = getListNetworkErrorMessage('courses');
            }
        }
    }
}
</script>
